import React from 'react';
import { useTranslation } from 'react-i18next';

function BtnAddWithoutToolTip({ onBtnClick, forDisable, masterAddEditAccess, addEditAccess }) {
  const { t } = useTranslation('common');

  return (
    <>
      {(masterAddEditAccess || addEditAccess) && (
        <button type="button" onClick={onBtnClick} className="filter-btn filter-button_add" disabled={forDisable} title={t('APPROVE_REJECTS.ADD')}>
          <span className="text-icon">{t('APPROVE_REJECTS.ADD')}</span>
          <i className="icon-add" />
        </button>
      )}
    </>
  );
}

export default BtnAddWithoutToolTip;
